module.exports = __webpack_public_path__ + "media/images/alambique-tablet-14eedf39a32f50d5108bef7f543e6061.jpg";